import { render } from "./AnnouncementDetail.vue?vue&type=template&id=72dd0dfa&ts=true"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=ts"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__